import { _ } from "extensions/underscore";

import { MapChart } from "common/components/charts/map";
import { getters } from "common/components/getters/getters";

import { DefaultView } from "../defaultView";
import trendlineWidgetTemplate from "./mapView.jst";

export const MapView = DefaultView.extend({
    type: "map",
    updateNote: false,
    template: trendlineWidgetTemplate,
    regions: {
        chart: ".map-chart"
    },
    
    events: {
        "click .widgetTitle": function(e) {
            e.preventDefault();
            this.drilldownToCorrespondingPage();
        },
        ...DefaultView.prototype.events
    },
    
    ui: {
        widgetTitle: ".map-name",
        widgetValue: ".widgetValue",
        ...DefaultView.prototype.ui
    },
    
    attributes() {
        return {
            ...DefaultView.prototype.attributes.apply(this, arguments),
            "gs-max-h": 6,
            "gs-min-h": 4,
            "gs-min-w": 4,
            "gs-max-w": 12
        };
    },

    setDataCollection() {
        const widgetCollectionParams = this.getOption("parent").getViewCollection({
            url: _.result(this, "getAPIEndpoint"),
            params: this.getRequestParams(),
            mode: this.getCollectionSortMode()
        });

        this.collection = widgetCollectionParams.collection;
        this.collection.queryParams.q = this.mergeFilters();
        this.skipReactOnChanges = !widgetCollectionParams.isNew;
        
        this.listenTo(this.collection, "before:fetched", () => {
            this.addSpinners();
        });
        this.listenTo(this.collection, "fetched", this.handleSucess.bind(this));
        this.listenTo(this.collection, "fetchError", this.handleError.bind(this));
        
        this.collection.trigger("react_fetched", this);
    },
    
    getLoadingChildren() {
        return this.ui.content.find(".widget-body");
    },

    handleSucess() {
        this.addChart();
    },
    
    addChart() {
        const self = this;
        const subtypeModel = this.model.subtypeModel;
        
        const chart = subtypeModel.getClone("map");
        let tooltipSettings;
        
        const tooltipData = this.model.get("options").chart.tooltipData;
        const tooltipString = "<div class='point-data'><span class='series-name'>$label:</span> <span class='point-y'>$value</span></div>";
        
        if (tooltipData) {
            tooltipSettings = {
                tooltip: {
                    formatter() {
                        // TODO: this is specific only to auth data. Remove dependency on "issuing_country" key
                        // TEMP implementation
                        
                        // Add header
                        const lines = [`<header>${this.key}</header>`];
                        
                        const data = this.series.chart.raw;
                        const formatValue = function(val, type) {
                            if (type === "amount") {
                                return self.formatAmountWithCurrentCurrency(val);
                            } if (type === "percentage") {
                                return `${self.formatNumber(val, 2)}%`;
                            }
                            
                            return self.formatNumber(val);
                        };
                        const dataToValue = function(extra, country) {
                            const dataPoint = _.findWhere(data, {
                                issuing_country: country
                            });
                            
                            let value;
                            if (_.isFunction(extra.key)) {
                                value = extra.key(dataPoint);
                            } else {
                                value = dataPoint[extra.key];
                            }
                            
                            return formatValue(value, extra.valueType);
                        };
                        
                        _.each(tooltipData, function(extra) {
                            lines.push(_.interpolate(tooltipString, {
                                label: extra.label,
                                value: dataToValue(extra, this.point.issuing_country)
                            }));
                        }, this);
                        
                        return lines.join("");
                    }
                }
            };
        } else {
            tooltipSettings = {
                tooltip: {
                    pointFormat: _.interpolate(tooltipString, {
                        label: "{series.name}",
                        value: "{point.value}"
                    })
                }
            };
        }
    
        const key = getters.findPivotKey(this.model.get("options").pivot);
    
        const chartView = new MapChart({
            height: Number.parseInt(this.$el.outerHeight() - this.$el.find(".header").outerHeight(true) - 20, 10), // 20 is hardcoded padding of the chart region
            collection: this.collection,
            processData(collection) {
                return collection.groupReduce({
                    groupBy: key,
                    reduceBy: subtypeModel.getClone("totals")
                });
            },
            chartOptions: _.deepExtend({
                mapNavigation: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        cursor: "pointer",
                        point: {
                            events: {
                                click() {
                                    self.drilldownToCorrespondingPage(this[key]);
                                }
                            }
                        }
                    }
                }
            }, tooltipSettings, chart.extend),
            series: chart.series
        });
        
        this.removeSpinners();
        this.showChildView("chart", chartView);
    },
    
    // Called from parent gridstack:init
    onGridstackInit() {
        this.addWidgetTitle();
        this.loadData();
    }
});
